<template>
  <div id="app">
    <router-view class="main" style="height: 100%;"> </router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "assets/css/style.scss";
  @import "assets/iconfont.css";
  #app {
    height: 100%;
  }
  html,body{
              height: 100%;
          }
</style>



// WEBPACK FOOTER //
// src/App.vue